import { TranslationMap } from '@trimble-gcs/i18n-types';

export function mapToolbarTranslations() {
  return {
    changeBackground: {
      tooltip: {
        text: $localize`:@@map.toolbar.changeBackground.tooltip:Change Background Map`,
        desc: 'Tooltip on the toolbar button that opens the background map selection dropdown.',
      },
      options: {
        street: {
          text: $localize`:@@map.toolbar.changeBackground.options.street:Street`,
          desc: 'Option in the background map selection dropdown that selects the street map.',
        },
        satellite: {
          text: $localize`:@@map.toolbar.changeBackground.options.satellite:Satellite`,
          desc: 'Option in the background map selection dropdown that selects the satellite map.',
        },
      },
    },
    fitToView: {
      text: $localize`:@@map.toolbar.fitToView:Fit to View`,
      desc: 'Tooltip on the toolbar button that fits the map to the original view.',
    },
    pan: {
      text: $localize`:@@map.toolbar.pan:Pan`,
      desc: 'Tooltip on the toolbar button that activates the pan tool.',
    },
    selectByPolygon: {
      text: $localize`:@@map.toolbar.selectByPolygon:Select by Polygon`,
      desc: 'Tooltip on the toolbar button that activates the polygon selection tool.',
    },
    selectByRectangle: {
      text: $localize`:@@map.toolbar.selectByRectangle:Select by Rectangle`,
      desc: 'Tooltip on the toolbar button that activates the rectangle selection tool.',
    },
    zoomIn: {
      text: $localize`:@@map.toolbar.zoomIn:Zoom In`,
      desc: 'Tooltip on the toolbar button that zooms in the map.',
    },
    zoomOut: {
      text: $localize`:@@map.toolbar.zoomOut:Zoom Out`,
      desc: 'Tooltip on the toolbar button that zooms out the map.',
    },
    clipByRectangle: {
      text: $localize`:@@map.toolbar.clipByRectangle:Clip by Rectangle`,
      desc:
        'Tooltip on the toolbar button that draws a rectangle clip region on the map ' +
        'for LAZ export. Unlike select by rectangle, this does not change list selection.',
    },
    clipByPolygon: {
      text: $localize`:@@map.toolbar.clipByPolygon:Clip by Polygon`,
      desc:
        'Tooltip on the toolbar button that draws a polygon clip region on the map ' +
        'for LAZ export. Unlike select by polygon, this does not change list selection.',
    },
  } satisfies TranslationMap;
}
